import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { compose } from 'redux';

import { FormattedMessage, injectIntl } from '../../../util/reactIntl';
import { Button, FieldSelect } from '../../../components';
import * as validators from '../../../util/validators';

import css from '../EditUserInfoModal.css';

const EditUserWeightSection = ({ intl, ...restProps }) => (
    <FinalForm
        {...restProps}
        render={fieldRenderProps => {
            const {
                handleSubmit,
                values,
                pristine,
                updateInProgress,
                form,
                initialValues,
            } = fieldRenderProps;
            const { userWeight: initialUserWeight } = initialValues;
            const disabled = !values.userWeight || pristine;

            const fieldRequiredMessage = intl.formatMessage({
                id: 'ProfileSettingsForm.fieldRequiredMessage',
            });

            const fieldRequired = validators.required(fieldRequiredMessage);

            const optionsList = [
                {
                    label: `< 40 kg`,
                    value: `< 40 kg`,
                },
                ...Array.from({ length: 61 }, (_, c) => ({
                    label: `${40 + c} kg`,
                    value: `${40 + c} kg`,
                })),
                {
                    label: `> 100 kg`,
                    value: `> 100 kg`,
                },
            ];

            return (
                <>
                    <FieldSelect
                        className={css.editUserExperinceEditSection}
                        type="text"
                        id="userWeight"
                        name="userWeight"
                        validate={fieldRequired}
                        form={form}
                        placeholder={intl.formatMessage({
                            id: 'ProfileSettingsForm.editUserInfoLabel-userWeight',
                        })}
                        optionsList={optionsList}
                    />

                    <div className={css.userDataProtectedMessage} />
                    <footer>
                        <Button
                            disabled={disabled}
                            onClick={handleSubmit}
                            inProgress={updateInProgress}
                        >
                            <FormattedMessage
                                id={`ProfileSettingsForm.editUserInfoAction-${
                                    initialUserWeight ? 'edit' : 'userWeight'
                                }`}
                            />
                        </Button>
                    </footer>
                </>
            );
        }}
    />
);

EditUserWeightSection.propTypes = {};

export default compose(injectIntl)(EditUserWeightSection);
